<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">余额</a></li>
            </ul>
        </div>

        <div id="usual1" class="usual">
            <div class="formbody">
                <div class="formtitle">
                    <span>账户余额</span>
                </div>
                
                <table class="tablelist">
                    <thead>
                        <tr>
                            <th>用户帐号金额</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <!-- 基本套餐余额信息 -->
                        <tr>
                            <td class="ea2020" style="width:20%">
                                总账户金额：
                            </td>
                            <td class="ea2020" style="text-align:left; width:20%;padding-left:8px;">{{ta.money}} 元</td>
                            <td style="width:20%;"></td>
                            <td style="width:20%;"></td>
                        </tr>
                        <tr v-for="item in userMoneyList">
                            <td style="width:20%;">
                                {{item.feename}}
                            </td>
                            <td style="text-align:left;width:20%;padding-left:8px;">{{item.fee}}
                                <template v-if="isApiUser == '0'">
                                    <label style="color: rgb(15, 99, 255); margin-left: 15px; cursor: pointer;" @click="showchargeaccount(item.feetype)" >划账</label>
                                </template></td>
                            <td style="width:20%;">
                                {{item.feefreename}}
                            </td>
                            <td style="text-align:left;width:20%;padding-left:8px;">{{item.feefree}}</td>
                        </tr>
                    </tbody>
                </table>
                
                <div class="jian">&nbsp;</div>
                <ul class="infolist">
                    <li><span class="ea2020 f16">扣款流程：</span></li>
                    <li><span>1、系统优先从功能账户中扣费，如功能账户不足，再向总账户扣费；</span></li> 
                    <li><span>2、用户今后从总账户向功能账户划账时，根据不同业务套餐或金额可享有大客户或VIP优惠（目前暂未开放）; </span></li>
                    <li><span>3、如功能账户没有余额而总账户仍有余额，仍可继续使用系统各功能；</span></li>  
                    <li><span>4、单向划账：总账户可划钱到功能账户，但不能从功能账户反划到总账户。</span></li> 
                </ul>
            </div>

            <div  v-show="chargeaccountShow" style="position: fixed; width:100%; height:100%; z-index:199; background:rgb(51, 51, 51); opacity: 0.6; 
                top: 0; left: 0;display: block;" @click="close()"/>
            <div class="tip" v-show="chargeaccountShow" style="display: block;width:400px;">
                <div class="tiptop"><span style="font-size: 16px;margin-left: 33%;">划 账 功 能</span><a @click="close()"></a></div>
                <table class="tablelist">
                    <tr>
                        <td style="height:50px;width: 200px;text-align: right;font-size: 13px;border:none;">
                            总账户余额
                        </td>
                        <td style="height:50px;border:none;">
                            <label style="color: coral;font-size: 16px;margin-right: 10px;margin-left:-40px;">{{ta.money}}</label>元
                        </td>
                    </tr>
                    <tr>
                        <td style="height:50px;width: 200px;text-align: right;border:none;">
                            从<label style="color: red;font-size: 14px;">总账户</label>划账至 <label style="color: red;font-size: 14px;">{{accountname}}账户</label>
                            <!-- 划账金额 -->
                        </td>
                        <td style="border:none;">
                            <input type="text" v-model="chargemoney" style="border: rgb(211, 203, 203) solid 0.1px;height:30px;padding-left: 10px;
                                width:100px;margin-left:-40px;" onkeyup="this.value=this.value.replace(/\D/g,'')">
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" height="80px;" style="text-align: center;">
                            <!-- <button style="color: white; background: rgb(56, 71, 209); cursor: pointer; font-size: 18px; border: solid 0.5px;
                                padding: 10px 20px 10px 20px;" @click="submitchargeaccount()">提交支付</button> -->
                                <input class="sure" type="button" :disabled="btndisabled" value="确认划账" @click="submitchargeaccount()">
                        </td>
                    </tr>
                </table>
            </div>

        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    data() {
        return {
            ta: {},
            //用户订购的业务
            tupList: [],
            //所有业务信息
            packageList: [],
            isApiUser: 0,
            productcodeList: [],
            code00: '',
            code10: '',
            code11: '',
            code20: '',
            code21: '',
            code22: '',
            code31: '',
            code32: '',
            code34: '',
            code35: '',
            code36: '',
            code37: '',
            code38: '',
            chargeaccountShow: false,
            feetype: '',
            accountname: '',
            chargemoney: '',
            userMoneyList:[],
            btndisabled:false,
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.getaccount();
    },
    methods: {
        getaccount() {
            var that = this;
            let data = {};
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/account.json",
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.userMoneyList = res.data.userMoneyList;
                    that.ta = res.data.tblAccount
                    that.tupList = res.data.tblUserPackageList
                    that.packageList = res.data.packageList
                    that.isApiUser = res.data.isApiUser
                    if(that.tupList.length > 0)
                    {
                        for(var i = 0; i < res.data.tblUserPackageList.length; i++)
                        {
                            that.productcodeList.push(that.tupList[i].productcode)
                        }
                    }
                    // console.log(that.tupList)
                    // console.log(that.productcodeList)
                    for(var i = 0; i <　that.productcodeList.length; i++)
                    {

                        if(that.productcodeList[i].includes("00"))
                        {
                            that.code00 = 'yes'
                        }
                        else
                        {
                            if(that.productcodeList[i].includes("10"))
                            {
                                that.code10 = 'yes'
                            }
                            if(that.productcodeList[i].includes("11"))
                            {
                                that.code11 = 'yes'
                            }
                            if(that.productcodeList[i].includes("20"))
                            {
                                that.code20 = 'yes'
                            }
                            if(that.productcodeList[i].includes("21"))
                            {
                                that.code21 = 'yes'
                            }
                            if(that.productcodeList[i].includes("22"))
                            {
                                that.code22 = 'yes'
                            }
                            if(that.productcodeList[i].includes("31"))
                            {
                                that.code31 = 'yes'
                            }
                            if(that.productcodeList[i].includes("32"))
                            {
                                that.code32 = 'yes'
                            }
                            if(that.productcodeList[i].includes("34"))
                            {
                                that.code34 = 'yes'
                            }
                            if(that.productcodeList[i].includes("35"))
                            {
                                that.code35 = 'yes'
                            }
                            if(that.productcodeList[i].includes("36"))
                            {
                                that.code36 = 'yes'
                            }
                            if(that.productcodeList[i].includes("37"))
                            {
                                that.code37 = 'yes'
                            }
                            if(that.productcodeList[i].includes("38"))
                            {
                                that.code38 = 'yes'
                            }
                        }
                    }
                }
                else
                {
                    alert(res.data.msg)
                    return false;
                }
            })
        },
        //关闭划账
        close() {
            if(confirm("取消划账？"))
            {
                this.chargemoney = ''
                this.chargeaccountShow = false
            }
            else
            {
                this.chargeaccountShow = true
            }
        },
        //点击划账功能
        showchargeaccount(feetype) {
            if(feetype == 'feemarketvoice')
            {
                this.accountname = "云电销"
            }
            else if(feetype == 'feesmsgj')
            {
                this.accountname = "国际短信"
            }
            else if(feetype == 'feeemail')
            {
                this.accountname = "邮件"
            }
            else if(feetype == 'feecode')
            {
                this.accountname = "云验证"
            }
            else if(feetype == 'feeliuliang')
            {
                this.accountname = "流量"
            }
            else if(feetype == 'margin')
            {
                this.accountname = "保证金"
            }
            else if(feetype == 'feeVip')
            {
                this.accountname = "vip"
            }
            else if(feetype == 'feesms')
            {
                this.accountname = "短信"
            }
            else if(feetype == 'feefaxsend')
            {
                this.accountname = "发传真"
            }
            else if(feetype == 'feefaxrec')
            {
                this.accountname = "收传真"
            }
            else if(feetype == 'fee400sub')
            {
                this.accountname = "400电话"
            }
            else if(feetype == 'feeweb800')
            {
                this.accountname = "网页800"
            }
            else if(feetype == 'feemeeting')
            {
                this.accountname = "会议"
            }
            else if(feetype == 'feedialphone')
            {
                this.accountname = "点击通话"
            }
            else if(feetype == 'feevoicesms')
            {
                this.accountname = "语音短信"
            }
            else if(feetype == 'feemms')
            {
                this.accountname = "彩信"
            }
            this.feetype = feetype
            this.chargeaccountShow = true
        },
        //提交划账
        submitchargeaccount() {
            if(this.chargemoney == '')
            {
                alert("划账金额不能为空!")
                return false;
            }
            else if(this.chargemoney == '0')
            {
                alert("划账金额不能为0!")
                return false;
            }
            else if(this.chargemoney < 50)
            {
                alert("划账金额不能小于50!")
                return false;
            }
            if(this.chargemoney > this.ta.money)
            {
                alert("划账金额不能大于总账户金额!")
                return false
            }
            this.btndisabled = true;
            var that = this
            let param = {'feetype': this.feetype, 'chargemoney': this.chargemoney}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/person/chargeaccount.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function(res) {
                if("0000000" == res.data.code)
                {
                    that.$alert("恭喜，划账" + that.chargemoney + "成功！ 赠送" + res.data.sendmoney + "元")
                    that.chargeaccountShow = false
                    that.chargemoney = ''
                    that.getaccount();
                    that.btndisabled = true;
                }
                else
                {
                    that.$alert(res.data.msg)
                    return false;
                }
            })
        },
        detail() {
            this.$router.push("/youhui")
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/person/account.vue